export default __webpack_public_path__ + "843a3d55e636c276543963e7203a9692.png";